import React from 'react';
import Navbar from '../components/Navbar';
import './Privacy.css';

function Privacy() {
    return (
        <div className="page-container privacy-page">
            <Navbar />

            <section className="privacy-hero">
                <div className="container">
                    <div className="privacy-hero-content">
                        <span className="section-badge">法的情報</span>
                        <h1 className="privacy-title">
                            プライバシー <span className="gradient-text">ポリシー</span>
                        </h1>
                        <p className="privacy-subtitle">
                            最終更新日：2026年3月19日
                        </p>
                    </div>
                </div>
            </section>

            <section className="privacy-content">
                <div className="container">
                    <div className="privacy-wrapper">
                        <div className="privacy-section">
                            <p>
                                本プライバシーポリシー（以下「本ポリシー」）は、本プラットフォームが利用者の情報を収集、使用、維持、および開示する方法を規定するものです。
                                また、本ポリシーでは、当社が当該の利用者情報に適用する慣行、利用者のプライバシー権、および自身の情報に関する選択肢についても説明します。
                                明確にするために、本ポリシーは本プラットフォームのすべての利用者（以下「学習者」、「お客様」）に適用されます。
                            </p>
                            <p>
                                本プラットフォームにアクセスして使用すること、個人の情報を提供すること、または選択肢が提示された際に同意を表明することにより、お客様は本ポリシーおよび利用規約に記載された情報の収集、使用、および開示に同意したものとみなされ、当社はそれらから生じるすべての責任を負わないものとします。
                                本ポリシーおよび/または利用規約のいずれかの規定に同意しない場合は、本プラットフォームへのアクセスまたは使用、あるいは当社との連絡を控え、直ちに本プラットフォームから退出する必要があります。
                                お客様が本プラットフォームに提供またはアップロードした情報が本ポリシーまたは利用規約の条項に違反している場合、当社はお客様にその旨を通知した上で当該情報を削除し、必要に応じてお客様に対して一切の責任を負うことなくアクセスを無効にする場合があります。
                                本プライバシーポリシーで使用されているが定義されていない用語については、当社の利用規約をご参照ください。
                                当社のプラットフォームにアクセスし、そこで提供されるサービスや製品を利用する前に、本ポリシーを注意深くお読みください。
                                ご不明な点がございましたら、以下の連絡先までお問い合わせください。
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>個人情報</h2>
                            <p>
                                「個人情報」とは、姓名、識別番号、メールアドレス、年齢、性別、所在地、写真、および/または本プラットフォームへの登録時またはそれ以降に提供された電話番号など、学習者を特定する情報を意味します。
                            </p>
                            <p>
                                「機密性の高い個人情報」には、(i) パスワードおよび財務データ（クレジットカード/デビットカードの下4桁を除く）、(ii) 健康データ、(iii) 公的識別番号（生体認証データ、マイナンバー、社会保障番号、運転免許証、パスポートなど）、(iv) 性生活、性的指向、人種、民族、政治的または宗教的信念、所属に関する情報、(v) アカウントの詳細およびパスワード、または (vi) 2011年情報技術（合理的なセキュリティ慣行および手順ならびに機密性の高い個人データまたは情報）規則、一般データ保護規則（GDPR）、および/またはカリフォルニア州消費者プライバシー法（CCPA）（以下「データ保護法」）および本ポリシーまたは他の同等/類似の法律の文脈において「機密性の高い個人データ」または「データの特別なカテゴリー」として分類されるその他のデータ/情報が含まれます。
                            </p>
                            <p>
                                「個人情報」という用語の使用には、その使用の文脈に応じて適用可能な場合、「機密性の高い個人情報」が含まれるものとします。
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>収集する情報</h2>
                            <p>
                                当社は、お客様が当社のプラットフォームにアクセスした際、プラットフォームに登録した際、および当社のプラットフォームで提供するその他の活動、サービス、機能、またはリソースに関連する場合を含め、さまざまな方法でお客様から個人を特定できる情報と特定できない情報の両方を収集する場合があります。ただし、以下の点にご注意ください。
                            </p>
                            <ul>
                                <li>当社は、プラットフォーム上のコンテンツへの登録時など、真に必要でない限り、お客様に個人情報を求めません。</li>
                                <li>当社は、適用法を遵守するため、製品やサービスを開発するため、あるいは当社の権利を保護するため以外に、お客様の個人情報を誰とも共有しません。</li>
                                <li>当社は、プラットフォームの継続的な運営に必要でない限り、当社のサーバーに個人情報を保存しません。</li>
                                <li>ユーザー生成コンテンツのアップロードには https://spayeeservers1.com を使用します。</li>
                            </ul>

                            <p><strong>個人を特定できる情報：</strong> 当社は、お客様のプラットフォームへのアクセスおよびそこで提供されるサービス/製品を可能にするために、お客様の氏名やメールアドレスなどの個人を特定できる情報を収集する場合があります。当社は、お客様が自発的に提供した場合にのみ、お客様から個人を特定できる情報を収集します。お客様はいつでも当該の個人情報の提供を拒否することができますが、その場合、プラットフォームで提供されるサービスや製品へのアクセス、またはプラットフォーム上の特定の活動への参加ができなくなる可能性があります。</p>

                            <p><strong>個人を特定できない情報：</strong> お客様が当社のプラットフォームを利用する際、当社はブラウザ名、言語設定、参照サイト、各ユーザーリクエストの日時、オペレーティングシステム、利用されたインターネットサービスプロバイダー、およびその他の同様の情報など、個人を特定できない情報を収集する場合があります。</p>

                            <p><strong>クッキー（Cookies）：</strong> ユーザー体験を向上させるために、当社のプラットフォームは「クッキー」を使用する場合があります。クッキーは、ウェブサイトが訪問者のコンピュータに保存し、訪問者が戻ってくるたびに訪問者のブラウザがウェブサイトに提供する、記録保持を目的とした一連の情報です。お客様は、ウェブブラウザの設定でクッキーを拒否したり、クッキーが送信される際に通知したりするように選択できますが、その場合、プラットフォームの一部が正しく機能しなくなる可能性があることにご注意ください。</p>
                        </div>

                        <div className="privacy-section">
                            <h2>収集した情報の使用および共有方法</h2>
                            <p>当社は、以下の目的でお客様の個人情報を収集および使用する場合があります：</p>
                            <ul>
                                <li><strong>当社のプラットフォームおよび/またはそこで提供されるサービス/製品へのアクセスを提供するため：</strong> 当社は、カスタマーサービスの提供、プラットフォームを通じた購入の履行、ユーザー情報の確認、および当社のプラットフォームの不具合の解決を含め（これらに限定されません）、お客様が本プラットフォームおよびそこで提供されるサービス/製品にアクセスできるように、収集したお客様の情報を使用します。</li>
                                <li><strong>当社のプラットフォームを改善し、安全性を維持するため：</strong> 当社は、当社が提供するプラットフォームおよびサービス/製品を改善およびカスタマイズするために、お客様の情報を使用します。さらに、犯罪活動、詐欺、当社のプラットフォームまたはネットワークの誤用や損害を防止、検出、調査し、対策を講じるためにお客様の情報を使用します。</li>
                                <li><strong>お客様との連絡、または当社のサービス/製品のマーケティングのため：</strong> 当社は、お客様から提供されたメールアドレスを使用して、本プラットフォームでのご注文、当社の特典、新製品、サービスについて連絡したり、プラットフォームに関するフィードバックを受け取ったりする場合があります。</li>
                            </ul>
                            <p>当社は、お客様の個人を特定できる情報を他者に販売、取引、またはその他の方法で悪用することはありません。上記に記載された目的に限定して、訪問者およびユーザーに関する、個人を特定できる情報にリンクされていない一般的な集計デモグラフィック情報を、当社のビジネスパートナーおよび信頼できる提携先と共有する場合があります。</p>
                        </div>

                        <div className="privacy-section">
                            <h2>お客様の権利</h2>
                            <p>一般に、すべての学習者は本セクションで規定される権利を有します：</p>
                            <ul>
                                <li><strong>確認およびアクセス権：</strong> お客様は、当社が保有するお客様の個人情報の確認およびアクセスを、他の裏付け情報とともに取得する権利を有します。</li>
                                <li><strong>訂正権：</strong> お客様は、当社が保有するお客様の個人情報が不正確であると思われる場合に、その修正を求める権利を有します。</li>
                                <li><strong>忘れられる権利：</strong> お客様は、特定の状況下で、お客様の個人情報の継続的な開示を制限または防止する権利を有します。</li>
                                <li><strong>消去権：</strong> お客様が当社のプラットフォームから個人情報を撤回/削除したい場合、お客様は個人情報の消去をリクエストする権利を有します。</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>国境を越えたデータの転送</h2>
                            <p>
                                個人情報を含むお客様の情報は、インドにあるAmazon Web Service (AWS) のサーバーおよびデータベースに保存、処理、および転送されます。
                                また、当社の提携先やサービスプロバイダーの所在地に応じて、他の国のサーバーで情報を保存、処理、および転送する場合もあります。
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>苦情・お問い合わせ</h2>
                            <p>
                                本ポリシーについてご質問がある場合、権利を行使したい場合、プライバシーに関する懸念や苦情がある場合は、詳細な説明を添えてメール（<a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a>）にてご連絡ください。
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Privacy;

